
import { Button, Select, Option, Checkbox, Alert } from 'element-ui';
import CardAddress from '@/pages/account/components/CardAddress.vue';
import { PlusIcon } from 'vue-feather-icons';
import addressMixin from '@/mixins/addressMixin.js';
import carriersMixin from '@/mixins/carriersMixin.js';
import cartMixin from '@/mixins/cartMixin.js';
import AddessForm from '@/pages/account/components/AddessForm.vue';
import SlideDownUp from '@/components/transitions/SlideDownUp.vue';
import AddessMobileForm from '@/pages/account/components/AddessMobileForm.vue';

// update address api on address mixin computed

export default {
  mixins: [addressMixin, carriersMixin, cartMixin],
  data() {
    return {
      hasOtherInvoiceAddress: false,
      idAddressEdit: null,
      idAddressInvoiceEdit: null,
      addressDeliveryNew: false,
    };
  },
  computed: {
    valide() {
      if (!this.getAddressDelivery?.MobilePhone) {
        return false;
      }
      if (!this.hasOtherInvoiceAddress) {
        return this.getAddressDelivery !== null;
      } else {
        return (
          this.getAddressDelivery !== null && this.getAddressInvoice !== null
        );
      }
    },
  },
  mounted() {
    const event = {
      valide: this.valide,
      addressDelivery: this.getAddressDelivery,
      addressInvoice: this.getAddressInvoice,
    };
    this.$emit('onChange', event);
  },
  watch: {
    valide() {
      const event = {
        valide: this.valide,
        addressDelivery: this.getAddressDelivery,
        addressInvoice: this.getAddressInvoice,
      };
      this.$emit('onChange', event);
    },
    addresses(val) {
      if (val.length) {
        if (this.idAddressDelivery !== this.idAddressInvoice) {
          this.hasOtherInvoiceAddress = true;
        }
      }
    },
  },
  methods: {
    scrollToTop() {
      if (process.client) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    },
    async removeCarrier() {
      const params = {
        idCarrier: 'null',
      };
      params.idRelayPoint = 'null';
      try {
        await this.cartService.setCarrierToCart(params);
        await this.cartService.fetchCart();
      } catch (error) {
        console.log('error', error);
      }
    },
    async onNewAddressDeliveryFormSubmit() {
      this.addressDeliveryNew = false;

      this.scrollToTop();
      await this.removeCarrier();
    },
    async onAddressFormSubmit() {
      this.scrollToTop();

      await this.removeCarrier();
      this.idAddressEdit = null;
      this.idAddressInvoiceEdit = null;
    },
    onAddressInvoiceFormSubmit() {
      this.idAddressInvoiceEdit = null;
      this.scrollToTop();
    },
    showNewAddForm() {
      this.idAddressEdit = null;
      this.idAddressInvoiceEdit = null;
      this.addressDeliveryNew = !this.addressDeliveryNew;

      this.scrollToTop();
    },
    showAddressFormEdit(event, idAddress) {
      event.stopPropagation();
      this.idAddressInvoiceEdit = null;
      this.addressDeliveryNew = false;
      if (this.idAddressEdit) {
        this.idAddressEdit = null;
      } else {
        this.idAddressEdit = idAddress;
      }

      this.scrollToTop();
    },
    showAddressInvoiceFormEdit(event, idAddress) {
      event.stopPropagation();
      this.idAddressEdit = null;
      this.addressDeliveryNew = false;

      if (this.idAddressInvoiceEdit) {
        this.idAddressInvoiceEdit = null;
      } else {
        this.idAddressInvoiceEdit = idAddress;
      }

      this.scrollToTop();
    },
    async checkBoxAddressInvoice(checked) {
      if (!checked) {
        //   if (this.idAddressDelivery) {
        //     try {
        //       this.idAddressInvoice = this.idAddressDelivery;
        //     } catch (error) {
        //     }
        //   }
        await this.addressService.updateAddressType({
          idAddress: this.idAddressDelivery,
          isDelivery: true,
          isInvoice: true,
        });
        await this.addressService.fetchAddresses();
      }
    },
    async updateAddressInvoice(event) {
      await this.addressService.updateAddressType({
        idAddress: event,
        isDelivery: this.idAddressDelivery === event,
        isInvoice: true,
      });
      await this.addressService.fetchAddresses();
    },
    async updateAddressDelivery(event) {
      await this.addressService.updateAddressType({
        idAddress: event,
        isDelivery: true,
        isInvoice: event === this.idAddressInvoice,
      });
      await this.addressService.fetchAddresses();

      this.carriersService.fetchCarrierTypes({
        idAddress: event,
        idCart: this.cartService.idCart,
        countryIsoCode: this.getAddressDelivery?.CountryIsoCode,
        country: this.getAddressDelivery?.Country,
        onSuccess: (data) => {
          if (this.carrierTypes) {
            this.carriersService.fetchCarriers({
              idAddress: event,
              idCart: this.cartService.idCart,
              countryIsoCode: this.getAddressDelivery?.CountryIsoCode,
              country: this.getAddressDelivery?.Country,
              carrierType: this.carrierTypes[0],
              responseLevel: 'details',
            });
            this.$store.commit('carriers/setActiveTab', this.carrierTypes[0]);
          }
        },
      });
    },
    async addressDeliveryChangeHandler(event) {
      this.updateAddressDelivery(event);
      this.idAddressEdit = null;

      await this.removeCarrier();
    },
    async addressInvoiceChangeHandler(event) {
      this.updateAddressInvoice(event);
      this.idAddressInvoiceEdit = null;
      await this.removeCarrier();
    },
    getAddressLabel(address) {
      if (!address) return '';
      return (
        (address?.Company ? address?.Company + ', ' : '') +
        address?.Address1 +
        ', ' +
        address?.Postcode +
        ' ' +
        address?.City +
        ', ' +
        address?.Country
      );
    },
  },
  components: {
    CardAddress,
    Button,
    Select,
    Option,
    Checkbox,
    PlusIcon,
    Alert,
    AddessForm,
    SlideDownUp,
    AddessMobileForm,
  },
};
